import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMapPin",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 1.5A3.5 3.5 0 0 0 2.5 5c0 1.302.885 2.68 1.874 3.793A15.182 15.182 0 0 0 6 10.36a15.182 15.182 0 0 0 1.626-1.567C8.615 7.68 9.5 6.303 9.5 5A3.5 3.5 0 0 0 6 1.5ZM6 11l-.3.4-.001-.001-.003-.002-.01-.008-.037-.028a14.688 14.688 0 0 1-.603-.5 16.177 16.177 0 0 1-1.42-1.404C2.615 8.32 1.5 6.697 1.5 5a4.5 4.5 0 0 1 9 0c0 1.698-1.115 3.32-2.126 4.457a16.177 16.177 0 0 1-2.023 1.904l-.036.028-.01.008-.004.002S6.3 11.4 6 11Zm0 0 .3.4a.5.5 0 0 1-.6 0L6 11Zm0-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM4 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function p(e, u, i, f, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--map-pin"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Map Pin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", p]]);
export {
  C as default
};
//# sourceMappingURL=map-pin.js.map
